import Vue from 'vue';

function floatNumber(value) {
  return value.toFixed(1);
}

Vue.filter('floatNumber', floatNumber);

export default floatNumber;
